const YOUTUBE_URL_PATTERN = /^https?:\/\/(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]{11})/

export function buildYoutubeEmbed (videoId) {
  return `<div class="video-embed"><iframe width="560" height="315" src="https://www.youtube.com/embed/${videoId}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe></div>`
}

function decodeHtmlEntitiesOnce (value) {
  if (typeof document === 'undefined') {
    return value
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, '\'')
      .replace(/&amp;/g, '&')
  }

  const textarea = document.createElement('textarea')
  textarea.innerHTML = value

  return textarea.value
}

export function normalizeRichHtml (html) {
  if (!html || typeof html !== 'string') {
    return ''
  }

  let result = html.trim()

  for (let i = 0; i < 3; i++) {
    if (!result.includes('&lt;') && !result.includes('&gt;') && !result.includes('&quot;')) {
      break
    }

    const decoded = decodeHtmlEntitiesOnce(result)

    if (decoded === result) {
      break
    }

    result = decoded
  }

  const urlOnly = result.match(YOUTUBE_URL_PATTERN)

  if (urlOnly) {
    return buildYoutubeEmbed(urlOnly[1])
  }

  return result
}
